const filters = {
	textonly: () => ((value) => value.replace(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/\d´`@#€¨\\]/ig, '')),
	maxlen: (length) => ((value) => (value.toString().length <= parseInt(length, 10) ? value : value.toString().substr(0, length))),
	integer: () => ((value) => value.replace(/[^\d]/ig, '')),
	float: () => ((value) => value.replace(/[^\d,\.,\-]/ig, '')),
	alphanumeric: () => ((value) => value.replace(/[^a-å0-9/\s/]+/gi, '')),
};

export default filters;
